import { atom } from 'recoil';

import { CheckBoxFilter } from '@shared/components/CheckboxFilter';

export const sellerAccountBugoBrandFilterAtom = atom<CheckBoxFilter>({
  key: 'sellerAccountBugoBrandFilterAtom',
  default: {},
});
